import { FlatListProps } from "./types"
import React, { useMemo, useCallback } from "react"
import { FlatList as InnerFlatList, Platform } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import { Swipeable } from "~widgets/swipeable"

type FlatListComponent<T = any> = React.FC<FlatListProps<T>>

const FlatList: FlatListComponent = ({
  data,
  extraData,
  swipeActionButtonConfigs,
  selecteds,
  renderItem,
  keyExtractor,
  ItemSeparatorComponent,
}) => {
  const isSelectMode = useMemo(() => !!selecteds, [selecteds])

  const renderItemInner = useCallback(
    ({ item }) => {
      return (
        <Swipeable item={item} actions={swipeActionButtonConfigs}>
          {renderItem({ item, isSelectMode, selecteds })}
        </Swipeable>
      )
    },
    [swipeActionButtonConfigs, isSelectMode, selecteds],
  )

  return (
    <div
      style={{
        flex: 1,
        width: "100%",
        alignSelf: "stretch",
        minHeight: 0,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <InnerFlatList
        style={Platform.OS === "web" ? { flex: 1, minHeight: 0, width: "100%" } : { flex: 1, width: "100%" }}
        showsVerticalScrollIndicator={false}
        data={data}
        extraData={extraData}
        renderItem={renderItemInner}
        keyExtractor={keyExtractor}
        ItemSeparatorComponent={ItemSeparatorComponent}
      />
    </div>
  )
}

export default observer(FlatList)
